import { useEffect, useSyncExternalStore } from 'react';
import { useAuthStore } from '@/store/auth.store';
import {
  applyEmbeddedDocumentFlag,
  isEmbeddedMode,
  postToNativeShell,
  subscribeEmbeddedMode,
} from '@/utils/embedded-console';

/** Whether the console runs embedded in the native app (set by /handoff only). */
export function useEmbeddedMode(): boolean {
  return useSyncExternalStore(subscribeEmbeddedMode, isEmbeddedMode, () => false);
}

/**
 * Mounted once at the app root. In embedded mode, tell the native shell the
 * moment the console session ends, however it ends: sign-out, the idle
 * timeout, a 401 / terminal revocation from the API (the issuing device
 * session was revoked), or an expired token at start-up. The shell then closes
 * the console and handles its own session. Outside embedded mode it does
 * nothing.
 */
export function useEmbeddedSessionBridge(): void {
  useEffect(() => {
    applyEmbeddedDocumentFlag();
    let wasAuthenticated = useAuthStore.getState().isAuthenticated;
    return useAuthStore.subscribe((state) => {
      const ended = wasAuthenticated && !state.isAuthenticated;
      wasAuthenticated = state.isAuthenticated;
      if (ended && isEmbeddedMode()) {
        postToNativeShell('session_ended');
      }
    });
  }, []);
}
